<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'ContactForm',

  props: {
    action: {
      type: String,
      required: true,
    },
    referrer: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      subject: '',
      message: '',
      // subscribe: false,

      errors: {},
      showSuccess: false
    }
  },

  watch: {
    first_name() { this.showSuccess = false },
    last_name() { this.showSuccess = false },
    email() { this.showSuccess = false },
    subject() { this.showSuccess = false },
    message() { this.showSuccess = false },
    // subscribe() { this.showSuccess = false },
  },

  methods: {
    submit() {
      this.showSuccess = false
      this.errors = {}

      const data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        subject: this.subject,
        message: this.message,
        // subscribe: this.subscribe,
        captcha_0: this.$refs.captcha.captchaKey,
        captcha_1: this.$refs.captcha.response,
        referrer: this.referrer,
      }

      const csrftoken = Cookies.get('csrftoken')
      console.log('csrf token:', csrftoken)
      axios.post(this.action, data, {'headers': { 'X-CSRFToken': csrftoken }}).then(
        this.success,
        this.error
      )
    },

    error(error) {
      this.errors = error.response.data.errors
      this.scrollToError()
      this.$refs.captcha.refresh()
      this.$nextTick(() => this.scrollToError())
    },

    success(response) {
      // this.showLandonEverythingIsOkSticker()
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.subject = ''
      this.message = ''
      // this.subscribe = false
      // Resetting the data above will cause showSuccess to be set false next
      // tick, so set it true using $nextTick rather than immediately
      this.$nextTick(function() { this.showSuccess = true })
      this.$refs.captcha.refresh()
    },
    
    getFocusableEls() {
      const focusables = this.$el.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')
      return Array.prototype.slice.call(focusables)
    },

    scrollToError() {
      const errorEls = [...this.$el.querySelectorAll('.error')]
      const firstError = errorEls.filter(el => el.tagName.toUpperCase() !== 'LEGEND')[0]

      if (firstError) {
        const focusTarget = this.getFocusableEls().filter(formEl => firstError.contains(formEl))
        focusTarget[0].focus()
      }
    },

  },
}
</script>



// WEBPACK FOOTER //
// js/ContactForm.vue